module.exports = __webpack_public_path__ + "img/pts.b17480a7.jpg";